import { float32ToPcm16Base64 } from "./pcm";

export const encodeAudioForAPI = (float32Array: Float32Array): string => {
  return float32ToPcm16Base64(float32Array);
};
